import { COLORS } from '@/constants';
import { FormControlLabel } from '@mui/material';
import styled from 'styled-components';

export const DialogHeadStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

export const FormBox = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
`;
export const StyledFormControlLabel = styled(FormControlLabel)`
  & .MuiRadio-root {
    color: black;
    padding: 0;

    .MuiSvgIcon-fontSizeMedium {
      width: 12px;
      height: 12px;
      padding-right: 10px;
      color: ${COLORS.orange};
    }
  }

  & .MuiFormControlLabel-label {
    font-size: 18px;
    font-weight: 400;

    @media (max-width: 700px) {
      font-size: 12px;
      font-weight: 300;
    }
  }
`;

export const BtnBox = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
